(() => {
  if (window.__ultraWhisper2EditableTabs) return;
  window.__ultraWhisper2EditableTabs = true;

  const activateTab = (tab) => {
    const section = tab.closest('.uw2-waves-v2');
    if (!section) return;

    const wave = tab.dataset.uw2Wave;
    const tabs = section.querySelectorAll('.uw2-waves-v2__tab[data-uw2-wave]');
    const panels = section.querySelectorAll('.uw2-waves-v2__feature[data-uw2-panel]');

    tabs.forEach((item) => {
      const selected = item === tab;
      item.classList.toggle('is-active', selected);
      item.setAttribute('aria-selected', selected ? 'true' : 'false');
      item.tabIndex = selected ? 0 : -1;
    });

    panels.forEach((panel) => {
      const active = panel.dataset.uw2Panel === wave;
      panel.hidden = !active;
      panel.classList.toggle('is-active', active);
    });
  };

  document.addEventListener('click', (event) => {
    const tab = event.target.closest('.uw2-waves-v2__tab[data-uw2-wave]');
    if (tab) activateTab(tab);
  });

  document.addEventListener('keydown', (event) => {
    const tab = event.target.closest('.uw2-waves-v2__tab[data-uw2-wave]');
    if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;

    const tabs = [...tab.closest('.uw2-waves-v2').querySelectorAll('.uw2-waves-v2__tab[data-uw2-wave]')];
    const current = tabs.indexOf(tab);
    let next = current;

    if (event.key === 'ArrowLeft') next = (current - 1 + tabs.length) % tabs.length;
    if (event.key === 'ArrowRight') next = (current + 1) % tabs.length;
    if (event.key === 'Home') next = 0;
    if (event.key === 'End') next = tabs.length - 1;

    event.preventDefault();
    tabs[next].focus();
    activateTab(tabs[next]);
  });
})();
